import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import FileIcon from '../../FileIcon';
import SharedTypography from '../../Typography';
const Download = ({ files }) => {
    return (_jsx(Stack, Object.assign({ maxHeight: "200px", spacing: 4, sx: {
            overflowY: 'auto',
            width: '100%',
            '&::-webkit-scrollbar': {
                width: '4px',
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '2px',
            },
            scrollbarWidth: 'thin',
            scrollbarColor: 'auto transparent',
        } }, { children: files.map((file, idx) => (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "center", paddingRight: "12px", spacing: 6 }, { children: [_jsxs(Stack, Object.assign({ direction: 'row', alignItems: 'center', spacing: 2 }, { children: [_jsx(FileIcon, { filename: file.name }), _jsx(SharedTypography, Object.assign({ variant: "body2", color: "text.dark", sx: {
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                width: '120px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                            }, clamp: 2 }, { children: file.name }))] })), _jsx(Typography, Object.assign({ textAlign: "right" }, { children: _jsx("a", Object.assign({ target: "_blank", rel: "noreferrer", style: { color: '#4E3BC9', fontWeight: 600, fontSize: '12px' }, href: file.url, download: true }, { children: "Download" })) }))] }), idx))) })));
};
export default Download;
